import { Component, OnInit } from '@angular/core';
import { HCPStatisticService } from '../../services/hcpstatistic.service';
import { BasicError } from '../../models/error/error';

import { ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';

import { Study } from '../../models/study';
import { User } from '../../models/user';
import { HCPGroupService } from '../../services/hcpgroup.service';
import { GroupService } from '../../services/group.service';
import { UserService } from '../../services/user.service';
import { ProfileService } from '../../services/profile.service';
declare var $: any;

@Component({
  selector: 'app-group-details-collaborator',
  templateUrl: './group-details-collaborator.component.html',
  styleUrls: ['./group-details-collaborator.component.css']
})
export class GroupDetailsCollaboratorComponent implements OnInit {
  public studyId: any;
  public users: User[] = [];
  public usersRef = {};
  public allusers: User[] = [];
  public isEmptyCol = false;
  public isEmptyColAllUsers = false;

  public lastUpdateCount = 0;
  public lastUpdateCountAllUsers = 0;
  public timeout = null;
  public timeoutAllUsers = null;

  public currentStudy = null;
  public ownUser = null;
  public isOwner = false;
  public removeUser = null;
  public removeUserSuccess = null;

  constructor(private statistics: HCPStatisticService,
    private route: ActivatedRoute, private location: Location, private hcpGroup: HCPGroupService, private groupService: GroupService,
    private userService: UserService, private profileService: ProfileService) { }

  ngOnInit() {
    this.users = [];
    this.route.paramMap.switchMap((params: ParamMap) => {
      this.studyId = params.get('id');
      this.getStudy(this.studyId);


      return this.hcpGroup.getCollaboratorsOfStudy(params.get('id'))
    }).subscribe(dd => {
      if (dd instanceof BasicError) {
        console.log('Error occured while reading study');
      } else if (dd instanceof Array) {
        const tmp = this.users.concat(dd);
        this.users = [];

        $('#datatable').dataTable().fnDestroy();

        this.users = tmp;


        this.profileService.getMyProfile().subscribe(my => {
          if (my instanceof BasicError) {
            console.log('Own profile could not be loaded');
          } else {
            for (const u of this.users) {
              this.usersRef[u.getID().toString()] = u;
              if (u.getID() === my.getID()) {
                this.ownUser = u;
              }
            }
            if (this.ownUser.getRole() !== undefined && this.ownUser.getRole() !== 'Study Collaborator') {
              this.isOwner = true;
            }
          }
        });

        if (this.users.length !== 0) {
          this.isEmptyCol = false;
        }
      }
    });

    if (this.users.length === 0) {
      this.isEmptyCol = true;
    }
  }


  /**
   * This function gets the actual study
   * @param studyId id of group
   */
  public getStudy(studyId: Study) {
    this.groupService.getGroupDetail(studyId.toString()).subscribe(data => {
      if (data instanceof BasicError) {
        console.log('Error occured while reading study');
      } else if (data instanceof Study) {
        this.currentStudy = data;
      }
    });
  }

  /*
   * This function updates the Rows with Userobj in the datatable
   */
  public updateRows() {
    if (this.lastUpdateCount !== this.users.length) {
      this.lastUpdateCount = this.users.length;

      if (this.timeout !== null) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(function () {
        $('#datatable').DataTable({
          'destroy': true,
          'pageLength': 25
        });
      }, 200);

    }
  }

  /*
   * This function gets all Users.
   */
  public getAllUsers() {
    $('#datatableAllUsers').dataTable().fnDestroy();
    this.lastUpdateCountAllUsers = 0;
    this.allusers = [];
    this.userService.getAllUsers().subscribe(data => {
      if (data instanceof BasicError) {
        console.log('Error occured while reading all users');
      } else if (data instanceof Array) {
        const tmp = this.allusers.concat(data);
        this.allusers = [];

        $('#datatableAllUsers').dataTable().fnDestroy();

        this.allusers = tmp;

        if (this.allusers.length !== 0) {
          this.isEmptyColAllUsers = false;
        }
      }
    });

    if (this.allusers.length === 0) {
      this.isEmptyColAllUsers = true;
    }
  }

  /**
   * This function updates the Rows with Userobj from all Users in the datatable
   */
  public updateRowsAllUsers() {
    if (this.lastUpdateCountAllUsers !== this.allusers.length) {
      this.lastUpdateCountAllUsers = this.allusers.length;

      if (this.timeoutAllUsers !== null) {
        clearTimeout(this.timeoutAllUsers);
      }

      this.timeoutAllUsers = setTimeout(function () {
        $('#datatableAllUsers').DataTable({
          'destroy': true,
          'pageLength': 10
        });
      }, 10);

    }
  }

  /**
   * Prepare removing user from collaborator list
   * @param user user to be removed
   */
  public prepareRemoveFromStudy(user: User) {
    this.removeUser = user;
    this.removeUserSuccess = null;

    $('#ModalDeleteRequest').modal();
  }

  /**
   * The user that should be removed from lists
   * @param user user to be removed
   */
  public removeUserFromStudy(user: User) {
    this.hcpGroup.removeCollaboratorFromStudy(this.currentStudy, user).subscribe(dd => {
      if (dd) {
        const index = this.users.indexOf(this.usersRef[user.getID().toString()], 0);
        if (index > -1) {
          this.lastUpdateCount = 0;
          $('#datatable').dataTable().fnDestroy();
          this.users.splice(index, 1);
        }
        this.usersRef[user.getID().toString()] = undefined;
        this.removeUserSuccess = true;
      } else {
        console.log('Could not remove user from collaborators list');
        this.removeUserSuccess = false;
      }
    });
  }

  /**
   * Function to add user as collaborator
   * @param user user to be added as collaborator
   */
  public addUserToStudy(user: User, owner: Boolean = false) {
    this.hcpGroup.addCollaboratorToStudy(this.currentStudy, user, owner).subscribe(dd => {
      if (dd) {
        // successful
        this.lastUpdateCount = 0;
        $('#datatable').dataTable().fnDestroy();
        this.users.push(user);
        this.usersRef[user.getID().toString()] = user;
      } else {
        // failed
        console.log('failed to add user to collaborator list');
      }
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/group-details-collaborator/group-details-collaborator.component.ts